module.exports = __webpack_public_path__ + "8942fe70ea69b19c420e5ef80a8c9463.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/shirt-surfboards-s.png
// module id = 1938
// module chunks = 0